import React from 'react';
import BravesClubhouseSvg from "./BravesClubhouseSvg.js";
import StoreMapCanvas from "../../../../pages/Retail/map/StoreMapCanvas.js";

export const ANALYTICS_CONFIG = {
  mapColClass: "col-md-7",
  listColClass: "col-md-5",
  mapMaxWidth: "600px",
  mapWidth: "100%"
};

// Drawing size (from BravesClubhouseSvg's viewBox). The drawing is taller than wide,
// so the shared canvas narrows it to fit the height instead of letting it grow tall.
const SVG_WIDTH = 793.12;
const SVG_HEIGHT = 962.84;

// Numbers are placed by the shared canvas from each zone's shape
// (or a zone's labelPosition in locations.json, if set).

const ClubhouseMap = (props) => (
  <StoreMapCanvas
    {...props}
    Background={BravesClubhouseSvg}
    width={SVG_WIDTH}
    height={SVG_HEIGHT}
    maxHeight={560}
  />
);

export default ClubhouseMap;
